import moment from "moment";

// A date with no time means the whole close day, not midnight at the start of it.
function claimWindowClose(close) {
  if (typeof close !== "string") return close;
  const dateOnly = moment(close, "YYYY-MM-DD", true);
  return dateOnly.isValid() ? dateOnly.endOf("day") : close;
}

export function isInClaimWindow(program) {
  const open = program?.claimsOpenDate;
  const close = program?.claimsCloseDate;
  if (!open || !close) return false;
  return moment().isBetween(open, claimWindowClose(close));
}

export function isClaimWindowClosed(program) {
  const close = program?.claimsCloseDate;
  if (!close) return false;
  return moment().isSameOrAfter(claimWindowClose(close));
}

export function isTerminalState(program) {
  const state = program?.programState;
  return state === "completed" || state === "inactive";
}

export function formatEarnings(raw, isTerminal) {
  const amt = Number(raw) || 0;
  // A finished program that earned nothing reads as a flat "0", not "0.00".
  if (isTerminal && amt === 0) return "0";
  return amt.toFixed(2);
}

export function resolveIsDollarBudget(isDollarBudget, program) {
  if (isDollarBudget != null) return isDollarBudget;
  return (program?.awardType || "").toLowerCase() !== "points";
}

export function buttonStyle(buttonTextColor) {
  return buttonTextColor ? { color: buttonTextColor } : {};
}
